// 아바타 획득 띠(레인 E): 위쪽 가장자리 가는 줄, 플레이 영역 중앙을 가리지 않고 포인터를 막지 않는다.
// 프레임마다 lastGain.serial 숫자 비교만 한다(바뀔 때만 글을 바꾼다).
import type { GameView } from '../shared/types';
import { avatarDef, AVATAR_GRADES } from '../shared/avatar';
import { FONT } from './dom';

const SHOW_MS = 3000;
const FADE_MS = 400;

export class AvatarToast {
  private readonly box: HTMLDivElement;
  private serial = -1;
  private hideAt = 0;
  private shown = false;

  constructor(root: HTMLElement, view?: GameView) {
    const b = document.createElement('div');
    b.dataset.testid = 'avatar-toast';
    b.setAttribute('role', 'status');
    b.style.cssText = 'position:absolute;left:50%;top:max(6px,env(safe-area-inset-top,0px));transform:translateX(-50%);max-width:min(90%,340px);padding:3px 14px;' +
      'border-radius:12px;background:rgba(8,10,22,.82);border:1.5px solid currentColor;font:900 13px ' + FONT + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
      'pointer-events:none;opacity:0;transition:opacity ' + FADE_MS + 'ms;z-index:30';
    root.appendChild(b);
    this.box = b;
    // 이미 있던 획득은 다시 알리지 않는다
    this.serial = view?.avatar?.lastGain?.serial ?? -1;
  }

  update(v: GameView, now: number = performance.now()): void {
    const g = v.avatar?.lastGain;
    if (g && g.serial !== this.serial) {
      this.serial = g.serial;
      const d = avatarDef(g.id);
      if (d) {
        if (g.gain === 'new') {
          this.box.textContent = (d.grade === 'rare' ? '레어 아바타 획득! ' : '아바타 획득! ') + d.name;
          this.box.style.color = AVATAR_GRADES[d.grade].color;
        } else {
          this.box.textContent = d.name + ' 조각 +1';
          this.box.style.color = AVATAR_GRADES[d.grade].color;
        }
        this.box.style.opacity = '1';
        this.shown = true;
        this.hideAt = now + SHOW_MS;
      }
    }
    if (this.shown && now >= this.hideAt) { this.shown = false; this.box.style.opacity = '0'; }
  }
}
